import React, {useState, useEffect, useRef} from "react";
import {Link} from "gatsby";
import ncsacwLogo from "assets/images/ncsacw-logo.svg";
import samhsaLogo from "assets/images/samhsa-logo.png";
import upwardIcon from "assets/images/icon-arrow_upward.svg";
import acfLogo from "assets/images/acf-logo.png";
import { ExternalIcon } from "components/ui";
import "styles/scss/styles.scss";

const Footer = ({cards, linksNav}) => {
  let timeout;
  const targetRefs = useRef([])
  const boxOneRef = useRef(null)
  const boxTwoRef = useRef(null)
  const boxThreeRef = useRef(null)
  const [activeToolTip, setActiveToolTip] = useState(null)

  const displayHover = idx => e => {
   let toolTipRef = targetRefs.current[idx]
   e.preventDefault()
   
    if(toolTipRef) {
      timeout = setTimeout(() => {
        setActiveToolTip(`tooltip-${idx + 1}`)
      }, 200)
    }
  }

  const removeHover = idx => e => {
    clearTimeout(timeout)
    setActiveToolTip(null)
  }

  const goToTop = () => {
    window.scrollTo({
        top: 0,
        behavior: "smooth",
    });
  };

  // const clearToolTip = (e) => {
  //   if (e.key === "Tab") {
  //     clearTimeout(timeout)
  //     setActiveToolTip(null)
  //   }
  // }

  // const trapFocus = (e) => {
  //   let lastFocusableElement = null
  //   let timeoutFocus = null

  //   e.preventDefault()
  
  //   if (e.key !== "Tab") {
  //     return;
  //   }
     
  //   if(targetRefs && targetRefs.length) {
  //     for(let i=0; i < targetRefs.length; i++) {
  //       if(!targetRefs.current[i].contains(document.activeElement)) {
  //         if(timeoutFocus) {
  //           clearTimeout(timeoutFocus)
  //         }
  //       }
  //     }

  //     if(targetRefs.current[0].contains(document.activeElement)) {
  //       targetRefs.current[0].blur()
  //       if(boxOneRef) {
  //         timeoutFocus = setTimeout(() => {
  //           boxOneRef.current.focus()
  //         }, 200)
  //       }
  //     }

  //     if(targetRefs.current[1].contains(document.activeElement)) {
  //       targetRefs.current[1].blur()
  //       if(boxTwoRef) {
  //         timeoutFocus = setTimeout(() => {
  //           boxTwoRef.current.focus()
  //         }, 200)
  //       }
  //     }

  //     if( targetRefs.current[2].contains(document.activeElement)) {
  //       targetRefs.current[2].blur()
  //       if(boxThreeRef) {
  //         timeoutFocus = setTimeout(() => {
  //           boxThreeRef.current.focus()
  //         }, 200)
  //       }
  //     }
      
  //     lastFocusableElement = document.activeElement
  //   }
  // }

  useEffect(() => {
    const isBrowser = typeof window !== "undefined"
    isBrowser && document.addEventListener("scroll", () => {
      const btt = document.getElementById("back-to-top");
      document.addEventListener("scroll", () => {
        if (window.scrollY > 300) {
          btt?.classList && btt?.classList.add('fade');
        } else {
          btt?.classList && btt?.classList.remove('fade');
        }
      })
    })

    // document.body.addEventListener('keyup', e => {
    //   trapFocus(e)
    // })
  }, []);
    useEffect(() => { 
      let count = 1;
      document.body.addEventListener('keydown', e => { 
        if (e.key !== 'Tab' ) {
           return 
          } 
        if(activeToolTip !== null) { 
          let focusableElements=`#${activeToolTip} button, #${activeToolTip} a[href]`;
          let firstFocusableElement=document?.querySelector(`#${activeToolTip}`)?.querySelectorAll(focusableElements)[0]; 
          let lastFocusableElement=document?.querySelector(`#${activeToolTip}`)?.querySelectorAll(focusableElements)[document?.querySelector(`#${activeToolTip}`)?.querySelectorAll(focusableElements).length-1]; 
          if(count === 1) { 
            firstFocusableElement?.focus() 
            e.preventDefault() 
            count++ 
          } 
          if(document.activeElement === lastFocusableElement) { 
            firstFocusableElement?.focus() 
            e.preventDefault() 
            count = 2 
          } 
        }
      })}, [activeToolTip])

    return (
      <footer className="usa-footer">
        <div className="blue-bg padding-y-5">
          <div className="grid-container">
            <h2 className="text-base-lightest">Find Help with a Personal Situation</h2>
            <div className="usa-card-group">
              {cards.map((card, idx) => {
                let toolTipItem = `tooltip-${idx + 1}`
                return (
                  <div className={`usa-card desktop:grid-col-4 ${activeToolTip === toolTipItem && "active-tooltip" }`} key={`card-${idx+1}`}>
                    <div className={`usa-card__container`}>
                      <div className="usa-card__header">
                        <h2 className="usa-card__heading">{card.title}</h2>
                      </div>
                      <div className="usa-card__body">
                      {card.id==="tooltip-1" ?
                      <>
                          <p className="desktop:display-block tablet:display-none mobile:display-none">To find treatment facilities confidentially, 24/7, please call 1-800-662-4357 (HELP).</p>
                          <p className="desktop:display-none tablet:display-block mobile:display-block">To locate general treatment services, visit the Substance Abuse and Mental Health Services Administration’s (SAMHSA’s) <a href="https://findtreatment.samhsa.gov/" target="_blank" rel="noreferrer">Treatment Locator</a> <ExternalIcon /> online or call <a href="tel:18006624357" className="text-bold">1-800-662-4357 (HELP)</a>. This service provides referrals to local treatment facilities, support groups, and community-based organizations. It is a free, confidential, 24-hour-a-day, 365-day-a year information service, in English and Spanish, for individuals and family members needing treatment for a mental and/or substance use disorder.</p>
                        </>:
                        card.id==="tooltip-2" ?
                        <>
                          <p className="desktop:display-block tablet:display-none mobile:display-none">If you suspect a child has been harmed by abuse or neglect, please call 1-800-422-4453.</p>
                          <p className="desktop:display-none tablet:display-block mobile:display-block">If you suspect that a child has been harmed or is at risk of being harmed by abuse or neglect, call the National Child Abuse Hotline at Call the National Child Abuse Hotline at <a href="tel:18004224453" className="text-bold">1-800-422-4453</a>. Serving the United States and Canada, the hotline is staffed 24 hours a day, 7 days a week with professional crisis counselors who—through interpreters—provide assistance in over 170 languages. All calls, texts, and chats are confidential. If you believe a child is in immediate danger of harm, call 911 first.</p>
                        </>:
                        card.id==="tooltip-3" &&
                        <>
                            <p className="desktop:display-block tablet:display-none mobile:display-none">For free and confidential support for people in distress, 24/7, please call or text 988, chat <a href="https://988lifeline.org/" target="_blank" rel="noreferrer">988Lifeline.org,</a> <ExternalIcon /> or call 1-800-273-8255.</p>
                            <p className="desktop:display-none tablet:display-block mobile:display-block">If you or someone you know is having thoughts of suicide or experiencing a mental health or substance use crisis, help is available and there are options to receive compassionate care. You can call or text 988 or chat <a href="https://988lifeline.org/" target="_blank" rel="noreferrer">988Lifeline.org</a>. <ExternalIcon /> You can also call the <a href="https://suicidepreventionlifeline.org/" tabIndex="0" target="_blank" rel="noreferrer">National Suicide Prevention Lifeline</a>  <ExternalIcon /> at <a href="tel:18002738255" className="text-bold">1-800-273-TALK (1-800-273-8255)</a>. Both are confidential and available 24/7 to everyone in the United States and will connect you to a trained counselor at a suicide crisis center nearest you.</p>
                          </>
                        }
                      </div>
                      <div 
                        className="usa-card__footer no-focus desktop:display-block tablet:display-none mobile-lg:display-none mobile:display-none card:display-none position-relative"
                        tabIndex="-1"  
                      >
                        <button type="button" className="usa-button primary-button width-full tooltipWrap no-focus" onClick={displayHover(idx)} onFocus={displayHover(idx)} tabIndex={0} ref={el => targetRefs.current[idx] = el} aria-label={idx === 0 ? `${card.linkText}: ${card.title}`:`${card.linkText} about the ${card.title}`}>
                          <span href={`#${card.id}`}>
                            {card.linkText}
                          </span>
                        </button>
                        <div  id={toolTipItem} className={`tooltip-footer-box ${activeToolTip === toolTipItem ? "tooltip-is-open" : 'tooltip-is-closed' } ${toolTipItem === "tooltip-1" ? "left-aligned" : toolTipItem === "tooltip-2" ? "center-aligned" : "right-aligned"} `}>
                          <div>
                            <button onClick={removeHover(idx)} aria-label="Close this tooltip">
                              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="black" viewBox="0 0 24 24"><path d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg>
                            </button>
                            {idx === 0 && <p>To locate general treatment services, visit the Substance Abuse and Mental Health Services Administration’s (SAMHSA’s) <a href="https://findtreatment.samhsa.gov/" tabIndex="0" target="_blank" rel="noreferrer" ref={boxOneRef} aria-label="Treatment Locator, open link in a new window">Treatment Locator</a> <ExternalIcon /> online or call <a href="tel:18006624357" tabIndex="0" aria-label="1-800-662-4357 (HELP)">1-800-662-4357 (HELP)</a>. This service provides referrals to local treatment facilities, support groups, and community-based organizations. It is a free, confidential, 24-hour-a-day, 365-day-a year information service, in English and Spanish, for individuals and family members needing treatment for a mental and/or substance use disorder.</p>}
                            {idx === 1 && <p>If you suspect that a child has been harmed or is at risk of being harmed by abuse or neglect, call the National Child Abuse Hotline at <a href="tel:1800422445" tabIndex="0" ref={boxTwoRef} aria-label="1-800-422-4453">1-800-422-4453</a>. Serving the United States and Canada, the hotline is staffed 24 hours a day, 7 days a week with professional crisis counselors who—through interpreters—provide assistance in over 170 languages. All calls, texts, and chats are confidential. If you believe a child is in immediate danger of harm, call 911 first.</p>}
                            {idx === 2 && <p>If you or someone you know are in crisis, thinking about harming yourself, attempting suicide, or harming another person, tell someone who can help right away. There are options to help you cope. Call the toll-free, 24-hour hotline of the <a href="https://suicidepreventionlifeline.org/" target="_blank" rel="noreferrer" tabIndex="0" ref={boxThreeRef} aria-label="National Suicide Prevention Lifeline, open link in a new window">National Suicide Prevention Lifeline</a> <ExternalIcon /> at <a href="tel:18002738255" tabIndex="0" aria-label="1-800-273-TALK (1-800-273-8255)">1-800-273-TALK (1-800-273-8255)</a> to be connected to a trained counselor at a suicide crisis center nearest you. The National Suicide Prevention Lifeline is confidential support, available 24/7 to everyone in the United States.</p>}
                          </div>
                        </div>
                
                      </div>
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
        </div>
        <div className="padding-y-3">
          <div className="grid-container">
            <div className="border-base-lighter border-bottom">
              <h3>Contact Us</h3>
              <p>The National Center on Substance Abuse and Child Welfare offers free technical assistance to a variety of systems on making policy and practice changes to improve outcomes for families affected by substance use disorders and involvement with child welfare services. To learn more about technical assistance services or if you have a question please email NCSACW at <a href="mailto:ncsacw@cffutures.org" onFocus={removeHover}>ncsacw@cffutures.org</a> or call toll-free at <a href="tel:18664932758">1–866–493–2758</a>.</p>
            </div>
            <div className="usa-footer__primary-section margin-y-2">
              <nav className="usa-footer__nav padding-left-0" aria-label="Footer navigation">
                <ul className="grid-row grid-gap desktop:grid-gap">
                  {linksNav.map((link, idx)=>{
                      return link.type ==="nav" &&
                      <li
                      key={`footer-nav-link-${idx}`}
                      className="
                      grid-col-auto
                      usa-footer__primary-content"
                      >
                        {link.externalIcon === true ?
                        <span className="usa-footer__primary-link">
                          <a href={link.link} target="_blank" rel="noreferrer" aria-label={`${link.linkText}, open link in a new window`}>{link.linkText}</a>
                          <ExternalIcon />
                        </span>
                        :
                          <Link className="usa-footer__primary-link" to={link.link} aria-label={`${link.linkText}`}>{link.linkText}</Link>
                        }
                    </li>
                  })}
                </ul>
              </nav>
            </div>
          </div>
        </div>
        <div className="usa-footer__secondary-section gray-bg padding-y-5">
          <div className="grid-container">
            <div className="grid-row grid-gap">
              <div className="tablet-lg:grid-col-3 tablet:grid-col-4" >
                <a href="https://www.acf.hhs.gov" target="_blank" rel="noreferrer"><img className="acf-footer-img" src={acfLogo} alt="Administration for Children & Families" /></a>
                <a href="https://www.samhsa.gov" target="_blank" rel="noreferrer"><img className="samhsa-footer-img margin-left-1"src={samhsaLogo} alt="Substance Abuse and Mental Health Services Administration" /></a>
              </div>
              <div className="tablet-lg:grid-col-9 tablet:grid-col-7">
                <a href="https://ncsacw.acf.hhs.gov" aria-label="National Center on Substance Abuse and Child Welfare">https://ncsacw.acf.hhs.gov</a>
                <p >An official website of the <a href="https://www.acf.hhs.gov" target="_blank" rel="noreferrer" aria-label="Administration for Children & Families, open in a new window">Administration for Children and Families </a >and the <a href="https://www.samhsa.gov/" target="_blank" rel="noreferrer" aria-label="Substance Abuse and Mental Health Services Administration, open in a new window"> Substance Abuse and Mental Health Services Administration</a><ExternalIcon iconColor="white" /></p>
              </div>
            </div>
            <nav className="grid-row" aria-label="Footer links">
              <section className="usa-footer__primary-content usa-footer__primary-content--collapsible">
                <ul className="usa-list usa-list--unstyled grid-row">
                  {linksNav.map((link, idx)=>{
                    return link.type==="link" &&
                    <li
                    key={`footer-link-${idx}`}
                    className="usa-footer__secondary-link tablet:grid-col-4 mobile-lg:grid-col-12 padding-right-2"
                    >
                     {(link.externalIcon === true && !link.link.includes("acf.hhs.gov"))?

                        <>
                          <a href={link.link} target="_blank" rel="noreferrer" aria-label={`${link.linkText}, open in a new window`}>{link.linkText}</a>
                          <ExternalIcon iconColor="white"/>
                        </>
                        :
                        link.link.includes("acf.hhs.gov")?
                        <a href={link.link} target="_blank" rel="noreferrer" aria-label={`${link.linkText}, open in a new window`}>{link.linkText}</a>
                        :
                          <Link to={link.link} aria-label={`${link.linkText}`}>{link.linkText}</Link>
                        }
                    </li>
                  })}
                </ul>
              </section>
              <p>Looking for U.S. government information and services? Visit <a href="https://www.usa.gov/" target="_blank" rel="noreferrer" aria-label="USA.gov, open in a new window">USA.gov</a><ExternalIcon iconColor="white"/>.</p>
            </nav>
          </div>
        </div>
        <div className="padding-5 text-center bg-white">
          <img src={ncsacwLogo} alt="National Center on Substance Abuse and Child Welfare" className="bg-white tablet:width-card-lg"/>
        </div>
        <div className="usa-footer__return-to-top">
          <button type="button" id="back-to-top" className={``} onClick={goToTop} aria-label="Back to top"><img src={upwardIcon} alt="Back to top"/></button>
        </div>
    </footer>
    )
}

export default Footer;

